<template>
  <div>
    <template v-if="loading">
      <div class="loading">
        <img :src="loadingGif" alt="loading"/>
      </div>
    </template>
    <template v-else>
      <get-started-modal
        v-if="displayingModalName === 'get-started'"
        @clickedRequestTempPin="displayingModalName = 'temporary-pin'" />
      <enter-passcode-modal
        v-else-if="displayingModalName === 'enter-passcode'"
        @clickedForgotPin="displayingModalName = 'temporary-pin'" />
      <temporary-pin-code-modal
        v-else-if="displayingModalName === 'temporary-pin'"
        :member-access-code.sync="memberAccessCode"
        @validTemporaryCode="displayingModalName = 'create-passcode'" />
      <create-passcode-modal
        v-else-if="displayingModalName === 'create-passcode'"
        :member-access-code="memberAccessCode" />
      <easy-code-flow-modal
        v-else-if="displayingModalName === 'easy-code-flow'"
        :member-access-code="memberAccessCode"
        :merchant-dba-name="merchantDbaName"/>
     </template>
  </div>
</template>

<script>
  import Modal from '../../components/shared/Modal';
  import PasscodeInput from '../../components/shared/PasscodeInput';
  import GetStartedModal from './GetStartedModal';
  import EasyCodeFlowModal from './EasyCodeFlowModal.vue';
  import EnterPasscodeModal from './EnterPasscodeModal.vue';
  import TemporaryPinCodeModal from './TemporaryPinCodeModal.vue';
  import CreatePasscodeModal from './CreatePasscodeModal.vue';
  import loadingGif from 'passcode/loading.gif';
  import { passcodeAPI } from "../../services/api/passcode";

  export default {
    name: "Passcode",

    data(){
      return {
        displayingModalName: '',
        loading: false,
        loadingGif,
        memberAccessCode: null,
        merchantDbaName: '',
      }
    },

    components: {
      CreatePasscodeModal,
      EasyCodeFlowModal,
      EnterPasscodeModal,
      GetStartedModal,
      Modal,
      PasscodeInput,
      TemporaryPinCodeModal
    },

    computed: {
      encodedSecureLinkId() {
        return this.$route.params.id;
      }
    },

    created(){
      this.loading = true;
      passcodeAPI.getCheckRememberMe(this.encodedSecureLinkId)
        .then(data => {
          /* This change is to show the easy code flow by default
             The BE has been updated to reflect this change so we handle it on the FE
          */
          if(data.easy_code_flow === false || data.easy_code_flow === true) {
            this.displayingModalName = 'easy-code-flow';
            this.merchantDbaName = data.merchant_dba_name;
          }
          else if(!!data.redirect_url && data.merchant_name){
            location.replace(data.redirect_url)
          } else {
            this.$router.push({
              name: 'Stashboard',
              params: {
                id: this.encodedSecureLinkId,
                anyLinks: data.any_link_extensions,
                appStoreUrl: data.app_store_url,
                content: data.sms_content,
                extensionType: data.type,
                googlePlayUrl: data.google_play_url,
                merchantName: data.merchant_name,
                merchantWebsiteUrl: data.website,
                stashboardHeaders: data.stashboard_headers,
                stashboardMedia: data.stashboard_media,
                urlButton: data.url,
                urlImage: data.mms_cdn_link
              }
            })
          }
        })
        .finally(() => this.loading = false);
    }
  }
</script>
